module.exports = __webpack_public_path__ + "media/images/icons/country_flags/tk-dda2603624dd706ba80be0ef4c32eed4.svg";